import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import "./style.css";

import { AuthLayout } from "../../Components/Layout/AuthLayout";
import CustomButton from "../../Components/CustomButton";
import CustomInput from "../../Components/CustomInput";
import { toast } from "react-toastify";
import { requestPermission } from "../../permissionRequest";

const AdminLogin = () => {
  const apiUrl = `${process.env.REACT_APP_BASE_URL}/user-login`;



  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    document.title = "Virtual PI | Login";
    let login = localStorage.getItem("login");
    if (login) {
      navigate('/dashboard')
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Prevent multiple submissions if a request is already in progress
    if (isLoading) return;

    setIsLoading(true);

    try {
      let messagingData = await requestPermission();

      const formDataMethod = new FormData();
      formDataMethod.append("email", formData.email);
      formDataMethod.append("password", formData.password);
      if (messagingData?.device_token) {
        formDataMethod.append("device_token", messagingData.device_token);
      }

      document.querySelector(".loaderBox").classList.remove("d-none");

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formDataMethod,
      });

      const responseData = await response.json();
      if (responseData.status) {
        // Only administrators (user_role === 1) may access the admin panel.
        if (Number(responseData.data.user_role) !== 1) {
          document.querySelector(".loaderBox").classList.add("d-none");
          toast.error("Access denied. Only administrators can log in here.");
          setIsLoading(false);
          return;
        }
        toast.success("Logged In Successfully!")
        localStorage.setItem("login", responseData.data.token);
        document.querySelector(".loaderBox").classList.add("d-none");
        navigate("/dashboard");
      } else {
        document.querySelector(".loaderBox").classList.add("d-none");
        toast.error(responseData.message || "Invalid Credentials")
        console.error("Login failed");
        setIsLoading(false);
      }
    } catch (error) {
      document.querySelector(".loaderBox").classList.add("d-none");
      toast.error("Unable to connect to the server. Please try again.");
      console.error("Error:", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <AuthLayout authTitle="Login" authPara="Login into your Account">
        <form onSubmit={handleSubmit}>
          <CustomInput
            label="Email Address"
            required
            id="userEmail"
            type="email"
            placeholder="Enter Your Email Address"
            labelClass="mainLabel"
            inputClass="mainInput"
            onChange={(event) => {
              setFormData({ ...formData, email: event.target.value });
            }}
          />
          <CustomInput
            label="Password"
            required
            id="pass"
            type="password"
            placeholder="Enter Password"
            labelClass="mainLabel"
            inputClass="mainInput"
            onChange={(event) => {
              setFormData({ ...formData, password: event.target.value });
            }}
          />
          {/* <div className="d-flex align-items-baseline justify-content-between mt-1">
            <div className="checkBox">
              <input
                type="checkbox"
                name="rememberMe"
                id="rememberMe"
                className="me-1"
              />
              <label htmlFor="rememberMe" className="fw-semibold">
                Remember Me
              </label>
            </div>
            <Link
              to={"/forget-password"}
              className="text-dark text-decoration-underline"
            >
              Forget Password?
            </Link>
          </div> */}
          <div className="mt-4 text-center">
            <CustomButton variant="primaryButton" text={isLoading ? "Logging in..." : "Login"} type="submit" disabled={isLoading} />
          </div>
        </form>
      </AuthLayout>
    </>
  );
};

export default AdminLogin;
